import {
  LayoutDashboard,
  User,
  Contact2,
  Quote,
  ScrollText,
  Shirt,
  ShoppingCart,
  PanelRightClose,
  PanelRightOpen,
} from "lucide-react"
import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Outlet, NavLink } from "react-router-dom"
import AdminAnalytics from "./AdminAnalytics"
import { fetchLeads } from "../../store/lead"
import { fetchQuotes } from "../../store/quote"
import { convertToCSV } from "../../util"
import "../styles/AdminPage.css"

const AdminPage = () => {
  const dispatch = useDispatch()
  const { auth } = useSelector((state) => state)
  const [isCollapsed, setIsCollapsed] = useState(false)

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const stats = [
    { title: "Total Sales", value: 65024, percentage: 81 },
    { title: "Site Visits", value: 24981, percentage: 58 },
    { title: "Searches", value: 14147, percentage: 21 },
  ]

  const exportLeadsToCSV = async () => {
    try {
      const leadsResponse = await dispatch(fetchLeads()).unwrap()
      if (!leadsResponse || leadsResponse.length === 0) {
        window.alert("No leads available to export.")
        return
      }
      const csvData = convertToCSV(leadsResponse)
      triggerCSVDownload(csvData, "leads.csv")
    } catch (error) {
      console.error("Error exporting leads:", error)
      window.alert("No Leads available to export.")
    }
  }

  const exportQuotesToCSV = async () => {
    try {
      const quotesResponse = await dispatch(fetchQuotes()).unwrap()
      if (!quotesResponse || quotesResponse.length === 0) {
        window.alert("No quotes available in database to export.")
        return
      }
      const csvData = convertToCSV(quotesResponse)
      triggerCSVDownload(csvData, "quotes.csv")
    } catch (error) {
      console.error("Error exporting quotes:", error)
      window.alert("No Quotes available in database to export.")
    }
  }

  const triggerCSVDownload = (csvData, filename) => {
    const blob = new Blob([csvData], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url)
  }

  if (!auth.isAdmin) {
    return (
      <div className="drawer-content">
        <h1>Not Authorized</h1>
      </div>
    )
  }

  return (
    <div className="admin-page">
      <div className="drawer md:drawer-open">
        <input id="adminSidebar" type="checkbox" className="drawer-toggle" />

        <div className={`drawer-side ${isCollapsed ? "collapsed" : ""}`}>
          <label htmlFor="adminSidebar" className="drawer-overlay"></label>

          <ul className="menu">
            <div className="dashboard">
              <li className="dashboard-title">
                <LayoutDashboard size={30} />
                DASHBOARD
              </li>
              <li>
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <User size={24} />
                  Users
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/leads"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <Contact2 size={24} />
                  Leads
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/quote"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <Quote size={24} />
                  Quotes
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/products"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <Shirt size={24} />
                  Products
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/orders"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <ShoppingCart size={24} />
                  Orders
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/admin/reviews"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <ScrollText size={24} />
                  Reviews
                </NavLink>
              </li>
            </div>
            <div className="collapse-expand-toggle" onClick={toggleCollapse}>
              {isCollapsed ? (
                <PanelRightClose size={26} />
              ) : (
                <PanelRightOpen size={26} />
              )}
            </div>
          </ul>
        </div>

        <div className="drawer-content">
          {/* <h1 className="admin-page-header">Admin Page</h1> */}
          <AdminAnalytics stats={stats} />
          <div className="exportBtn-container">
            <button className="exportBtn" onClick={exportLeadsToCSV}>
              Leads to CSV
            </button>
            <button className="exportBtn" onClick={exportQuotesToCSV}>
              Quotes to CSV
            </button>
          </div>
          <Outlet />
          <label htmlFor="adminSidebar" className="drawer-button"></label>
        </div>
      </div>
    </div>
  )
}

export default AdminPage
